import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { User } from '../micro-services/user/models/user';
import { ApiProviderService } from './api-provider.service';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root',
})
export class ClientService {
  private clientsSubject = new BehaviorSubject<User[]>([]);
  clients$ = this.clientsSubject.asObservable();

  constructor(
    private apiProviderService: ApiProviderService,
    private userService : UserService
  ) {
    this.loadClients();
  }

  private loadClients(): void {
    const coach = this.userService.getUser(); 
    if (coach) {
      this.apiProviderService.getUsersByCoach(coach.id)
        .subscribe(
          (res: User[]) => {
            const activeClients = res.filter(client => client.isActive);
            this.updateClients(activeClients);
          },
          (err) => {
            console.error('Erreur lors de la recherche des clients :', err);
            this.updateClients([]);
          }
        );
    }
  }

  updateClients(updatedClients: User[]): void {
    this.clientsSubject.next(updatedClients);
  }
  
}